import { PrivacyPolicy } from '../../../common/pages/PrivacyPolicy';

export const PrivacyPolicyErates = () => {
  return <PrivacyPolicy ownerTitle="eRates" updatedText="Last Updated May 02, 2023" />;
};
